import React, { useState } from 'react';
import { Paper, Typography, Button, Box, Grid, Divider } from '@mui/material';
import PoTable from './PoTable';
import { useDispatch, useSelector } from 'react-redux';
import { formateDate } from '../../../../Website/utils/utils';
import { useNavigate } from 'react-router-dom';
import { addToScheduleThunk } from '../../../../Website/redux/ScheduleSlice';

const PODetailsComp = ({ id }) => {
    const { loading, orderDetails } = useSelector(state => state.scheduleOrder);
    const navigate = useNavigate();
    const [selectedItems, setSelectedItems] = useState([]);
    const dispatch = useDispatch();
    const [reorderloading, setreorderloading] = useState(false);

    const handleReorder = async () => {
        const data = orderDetails?.products?.map((i) => ({
            productId: i?.productId?._id,
            totalQty: parseInt(i?.totalQty, 10),
            quantity: parseInt(i?.quantity, 10),
        }));
        setreorderloading(true);
        const status = await dispatch(addToScheduleThunk(data));
        setreorderloading(false);

        if (status?.payload === 200) {
            navigate('/scheduleCart');
        }
    };

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '60px 0' }}>
                <img src="/assets/__Iphone-spinner-1.gif" alt="loading" style={{ width: 35, height: 35 }} />
            </Box>
        );
    }

    return (
        <Paper sx={{ width: '100%', borderRadius: '16px', boxShadow: '0 4px 24px rgba(0,0,0,0.06)', overflow: 'hidden', border: '1px solid #f1f5f9' }}>
            {/* Header Bar */}
            <Box sx={{ padding: '24px 30px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#fafafa', borderBottom: '1px solid #f1f5f9', flexWrap: 'wrap', gap: '16px' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                    <Typography sx={{ fontSize: "20px", color: '#0f172a', fontWeight: '700', fontFamily: 'inherit' }}>
                        PO Details
                    </Typography>
                    <Typography sx={{ color: '#cbd5e1' }}>•</Typography>
                    <Typography sx={{ fontSize: '13px', color: '#64748b', fontWeight: '500' }}>
                        {formateDate(orderDetails?.createdAt)}
                    </Typography>
                    {orderDetails?.userId?.fullName && (
                        <>
                            <Typography sx={{ color: '#cbd5e1' }}>•</Typography>
                            <span style={{
                                backgroundColor: 'rgba(81, 45, 168, 0.08)',
                                color: '#512DA8',
                                padding: '4px 10px',
                                borderRadius: '12px',
                                fontSize: '12px',
                                fontWeight: '600'
                            }}>
                                Created by {orderDetails?.userId?.fullName}
                            </span>
                        </>
                    )}
                </Box>

                <Button
                    onClick={() => navigate(-1)}
                    variant="outlined"
                    size="small"
                    sx={{
                        color: '#512DA8',
                        borderColor: '#512DA8',
                        borderRadius: '8px',
                        textTransform: 'none',
                        fontSize: '13px',
                        fontWeight: '600',
                        padding: '6px 14px',
                        '&:hover': {
                            background: 'rgba(81, 45, 168, 0.04)',
                            borderColor: '#4527a0'
                        }
                    }}
                >
                    Back to List
                </Button>
            </Box>

            <Box sx={{ padding: '24px 30px', display: 'flex', flexDirection: 'column', gap: '20px' }}>
                {/* PO Stats Summary Bar */}
                <Box sx={{
                    display: 'flex',
                    justify: 'space-between',
                    alignItems: 'center',
                    background: '#ffffff',
                    border: '1px solid #e2e8f0',
                    borderRadius: '12px',
                    padding: '16px 24px',
                    flexWrap: 'wrap',
                    gap: '16px'
                }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '24px', flexWrap: 'wrap' }}>
                        <Box>
                            <Typography sx={{ fontSize: '12px', color: '#94a3b8', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                PO #
                            </Typography>
                            <Typography sx={{ fontSize: '15px', fontWeight: '700', color: '#0f172a', marginTop: '2px' }}>
                                #{orderDetails?._id}
                            </Typography>
                        </Box>

                        <Divider orientation="vertical" flexItem sx={{ height: '32px' }} />

                        <Box>
                            <Typography sx={{ fontSize: '12px', color: '#94a3b8', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                Scheduled Period
                            </Typography>
                            <Typography sx={{ fontSize: '15px', fontWeight: '700', color: '#0f172a', marginTop: '2px' }}>
                                {orderDetails?.period} months
                            </Typography>
                        </Box>

                        {orderDetails?.deliveredDate && (
                            <>
                                <Divider orientation="vertical" flexItem sx={{ height: '32px' }} />
                                <Box>
                                    <Typography sx={{ fontSize: '12px', color: '#94a3b8', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                        Last Delivery
                                    </Typography>
                                    <Typography sx={{ fontSize: '15px', fontWeight: '700', color: '#0f172a', marginTop: '2px' }}>
                                        {formateDate(orderDetails?.deliveredDate)}
                                    </Typography>
                                </Box>
                            </>
                        )}
                    </Box>

                    <Box sx={{ display: 'flex', gap: '10px' }}>
                        {selectedItems?.length > 0 && (
                            <Button
                                onClick={() => navigate(`/reshedule/${id}`, { state: selectedItems })}
                                variant="contained"
                                size="small"
                                sx={{
                                    background: '#512DA8',
                                    borderRadius: '8px',
                                    textTransform: 'none',
                                    fontSize: '13px',
                                    fontWeight: '600',
                                    padding: '6px 16px',
                                    '&:hover': { background: '#4527a0' }
                                }}
                            >
                                Reschedule ({selectedItems.length})
                            </Button>
                        )}
                        {orderDetails?.status === "COMPLETED" && (
                            <Button
                                onClick={handleReorder}
                                disabled={reorderloading}
                                variant="contained"
                                size="small"
                                sx={{
                                    background: '#512DA8',
                                    borderRadius: '8px',
                                    textTransform: 'none',
                                    fontSize: '13px',
                                    fontWeight: '600',
                                    padding: '6px 16px',
                                    '&:hover': { background: '#4527a0' }
                                }}
                            >
                                {reorderloading ? "Please wait..." : "Reorder"}
                            </Button>
                        )}
                    </Box>
                </Box>

                {/* Shipping & Order Summary Grid */}
                <Grid container spacing={3}>
                    <Grid item xs={12} md={7}>
                        <Paper sx={{ padding: '20px 24px', borderRadius: '12px', border: '1px solid #e2e8f0', boxShadow: 'none', height: '100%' }}>
                            <Typography sx={{ fontSize: '12px', fontWeight: '700', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '14px' }}>
                                Shipping Address
                            </Typography>
                            <Typography sx={{ fontSize: '15px', fontWeight: '700', color: '#0f172a' }}>
                                {orderDetails?.shippingAddress?.factoryUnits || 'Factory / Unit Details'}
                            </Typography>
                            <Typography sx={{ fontSize: '13.5px', color: '#475569', marginTop: '6px', lineHeight: '1.5' }}>
                                {[orderDetails?.shippingAddress?.streetAddress, orderDetails?.shippingAddress?.state, orderDetails?.shippingAddress?.country].filter(Boolean).join(', ')}
                            </Typography>

                            <Box sx={{ display: 'flex', gap: '24px', marginTop: '16px', flexWrap: 'wrap' }}>
                                {orderDetails?.userId?.email && (
                                    <Box>
                                        <Typography sx={{ fontSize: '11px', color: '#94a3b8', fontWeight: '600' }}>EMAIL</Typography>
                                        <Typography sx={{ fontSize: '13px', color: '#0f172a', fontWeight: '500', marginTop: '2px' }}>
                                            {orderDetails.userId.email}
                                        </Typography>
                                    </Box>
                                )}
                                {orderDetails?.userId?.phone && (
                                    <Box>
                                        <Typography sx={{ fontSize: '11px', color: '#94a3b8', fontWeight: '600' }}>PHONE</Typography>
                                        <Typography sx={{ fontSize: '13px', color: '#0f172a', fontWeight: '500', marginTop: '2px' }}>
                                            {orderDetails.userId.phone}
                                        </Typography>
                                    </Box>
                                )}
                            </Box>
                        </Paper>
                    </Grid>

                    <Grid item xs={12} md={5}>
                        <Paper sx={{ padding: '20px 24px', borderRadius: '12px', border: '1px solid #e2e8f0', boxShadow: 'none', background: '#fafafa' }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #e2e8f0', paddingBottom: '12px', marginBottom: '14px' }}>
                                <Box>
                                    <Typography sx={{ fontSize: '11px', color: '#94a3b8', fontWeight: '600', textTransform: 'uppercase' }}>ORDER ID</Typography>
                                    <Typography sx={{ fontSize: '14px', fontWeight: '700', color: '#0f172a' }}>#{orderDetails?._id}</Typography>
                                </Box>
                                <Box sx={{ textAlign: 'right' }}>
                                    <Typography sx={{ fontSize: '11px', color: '#94a3b8', fontWeight: '600', textTransform: 'uppercase' }}>PAYMENT METHOD</Typography>
                                    <Typography sx={{ fontSize: '14px', fontWeight: '700', color: '#0f172a', textTransform: 'uppercase' }}>Offline</Typography>
                                </Box>
                            </Box>

                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px' }}>
                                    <Typography sx={{ color: '#64748b' }}>Subtotal</Typography>
                                    <Typography sx={{ fontWeight: '600', color: '#0f172a' }}>₹{orderDetails?.priceBreakup?.subTotal || 0}</Typography>
                                </Box>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px' }}>
                                    <Typography sx={{ color: '#64748b' }}>Tax</Typography>
                                    <Typography sx={{ fontWeight: '600', color: '#0f172a' }}>₹{orderDetails?.priceBreakup?.tax || 0}</Typography>
                                </Box>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px' }}>
                                    <Typography sx={{ color: '#64748b' }}>Shipping</Typography>
                                    <Typography sx={{ fontWeight: '600', color: '#10b981' }}>Free</Typography>
                                </Box>
                                <Divider sx={{ my: '4px' }} />
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', fontSize: '15px' }}>
                                    <Typography sx={{ fontWeight: '700', color: '#0f172a' }}>Total</Typography>
                                    <Typography sx={{ fontWeight: '800', color: '#512DA8', fontSize: '16px' }}>₹{orderDetails?.priceBreakup?.total || 0}</Typography>
                                </Box>
                            </Box>
                        </Paper>
                    </Grid>
                </Grid>

                {/* Products Table */}
                <Box sx={{ marginTop: '10px' }}>
                    <PoTable
                        data={orderDetails?.products}
                        orderDetails={orderDetails}
                        status={orderDetails?.status}
                        selectedItems={selectedItems}
                        setSelectedItems={setSelectedItems}
                    />
                </Box>
            </Box>
        </Paper>
    );
};

export default PODetailsComp;
